"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var minus_1 = require("../icons/minus");
var plus_1 = require("../icons/plus");
var classnames_1 = __importDefault(require("classnames"));
var styledLayout_1 = require("../base/styledLayout");
var defaultNumericCounterProps = {
    onChange: function (_) { },
    fallBack: function (_) { },
    initialCounter: 0,
    min: -Infinity,
    max: Infinity,
    changeAmount: 1,
};
exports.NumericCounter = function (userProps) {
    var _a = __assign(__assign({}, defaultNumericCounterProps), userProps), onChange = _a.onChange, fallBack = _a.fallBack, initialCounter = _a.initialCounter, min = _a.min, max = _a.max, changeAmount = _a.changeAmount, controlledValue = _a.controlledValue;
    var _b = React.useState(initialCounter), counter = _b[0], setCounter = _b[1];
    var decrement = function () {
        if (controlledValue !== undefined && controlledValue > min) {
            return onChange(controlledValue - changeAmount);
        }
        var nextCounter = Number(counter) - changeAmount;
        if (nextCounter < min) {
            return fallBack(nextCounter);
        }
        setCounter(nextCounter);
        return onChange(nextCounter);
    };
    var increment = function () {
        if (controlledValue !== undefined && controlledValue < max) {
            return onChange(controlledValue + changeAmount);
        }
        var nextCounter = Number(counter) + changeAmount;
        if (nextCounter > max) {
            return fallBack(nextCounter);
        }
        setCounter(nextCounter);
        return onChange(nextCounter);
    };
    var onInput = function (e) {
        var val = parseInt(e.currentTarget.value);
        if (isNaN(val)) {
            return setCounter('');
        }
        if (val < min || val > max) {
            return fallBack(val);
        }
        setCounter(val);
        return onChange(val);
    };
    var onBlur = function () {
        // tslint:disable-next-line: radix
        if (isNaN(parseInt(counter.toString()))) {
            setCounter(min);
            return onChange(min);
        }
    };
    React.useEffect(function () {
        if (counter > max) {
            setCounter(max);
        }
    }, [max]);
    React.useEffect(function () {
        var numberControlledValue = Number(controlledValue);
        if (numberControlledValue >= min && numberControlledValue <= max) {
            setCounter(numberControlledValue);
        }
    }, [controlledValue]);
    return (React.createElement(styledLayout_1.StyledLayout, { className: "ty-numeric-counter" },
        React.createElement("button", { onClick: decrement, className: classnames_1.default('ty-numeric-counter-button', { passive: counter <= min }) },
            React.createElement(minus_1.Minus, null)),
        typeof controlledValue !== undefined ? (React.createElement("span", { className: "counter-content" }, counter)) : (React.createElement("input", { className: "counter-content", onInput: onInput, onBlur: onBlur, type: "text", pattern: "[0-9]*", value: counter })),
        React.createElement("button", { onClick: increment, className: classnames_1.default('ty-numeric-counter-button', { passive: counter >= max }) },
            React.createElement(plus_1.Plus, null))));
};
